import { css } from '@emotion/react';

const semiTransparentBlack = `rgba(0, 0, 0, 0.5)`;

const customScrollbar = css`
  scrollbar-color: ${semiTransparentBlack} transparent;

  ::-webkit-scrollbar {
    width: 8px;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: ${semiTransparentBlack};
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-button {
    display: none;
  }
`;

export default customScrollbar;
